import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// API
import * as API from '../../../../utils/api';


class ManagedPhotoDeleter extends Component {
  static propTypes = {
    photoID: PropTypes.number.isRequired,
    updateParticipation: PropTypes.func.isRequired,

    // from redux
    user: PropTypes.object
  }

  deletePhoto = () => {
    const { user, photoID, updateParticipation } = this.props

    API.deletePhoto(user, photoID)
    .then(updateParticipation)
  }

  render() {
    return(
      <div className="managed-photo-deleter" onClick={this.deletePhoto}>
        <svg className="icon managed-photo-deleter-icon"><use xlinkHref="#trash-can" /></svg>
        <span>Delete Photo</span>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps)(ManagedPhotoDeleter)



// WEBPACK FOOTER //
// ./src/components/UserPortal/Locker/PhotoVideo/ManagedPhotoDeleter.js